var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCoins(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_38154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7C15.75 3.13425 21.6265 0 28.875 0C36.1235 0 42 3.13425 42 7C42 10.8658 36.1235 14 28.875 14C21.6265 14 15.75 10.8658 15.75 7ZM28.875 17.5C27.0778 17.5 25.3733 17.2988 23.8158 16.9488C21.4375 15.1655 17.5403 14 13.125 14C5.8765 14 0 17.1342 0 21C0 24.8658 5.8765 28 13.125 28C20.3735 28 26.25 24.8658 26.25 21C26.25 20.9493 26.2377 20.9002 26.236 20.8495H26.25V24.5C26.25 28.3658 20.3735 31.5 13.125 31.5C5.8765 31.5 0 28.3658 0 24.5V28C0 31.8658 5.8765 35 13.125 35C20.3735 35 26.25 31.8658 26.25 28V31.5C26.25 35.3658 20.3735 38.5 13.125 38.5C5.8765 38.5 0 35.3658 0 31.5V35C0 38.8658 5.8765 42 13.125 42C20.3735 42 26.25 38.8658 26.25 35V34.86C27.0988 34.951 27.9755 35 28.875 35C36.1235 35 42 31.8658 42 28V24.5C42 28.2082 36.589 31.2357 29.75 31.4772V27.9773C36.589 27.7358 42 24.71 42 21V17.5C42 21.2082 36.589 24.2358 29.75 24.4773V20.9773C36.589 20.7358 42 17.71 42 14V10.5C42 14.3658 36.1235 17.5 28.875 17.5Z",
    fill: "#F3D266"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_38154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCoins);
export default __webpack_public_path__ + "static/media/Profile-coins.a41559560854cd975e7492334e7778e7.svg";
export { ForwardRef as ReactComponent };